<template>
  <div class="contact-page">
    <!-- QR Code Modal -->
    <div v-if="showQRModal" class="modal-overlay" @click.self="closeQRModal">
      <div class="modal-content">
        <button class="modal-close" @click="closeQRModal">×</button>
        <h3>加入 QQ 群</h3>
        <p>扫描二维码加入用户交流群</p>
        <img src="~@/assets/img/qqcode2.png" alt="QQ群二维码" class="qr-image"/>
      </div>
    </div>

    <!-- Header -->
    <section class="page-header">
      <div class="container">
        <span class="section-eyebrow animate-on-scroll">CONTACT</span>
        <h1 class="animate-on-scroll aos-delay-1">联系我</h1>
        <p class="animate-on-scroll aos-delay-2">有问题或建议？欢迎随时取得联系</p>
      </div>
    </section>

    <!-- Contact Options -->
    <section class="contact-options">
      <div class="container">
        <div class="contact-grid">
          <div class="contact-card animate-on-scroll">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <h3>问题反馈</h3>
            <p>遇到 Bug 或有功能建议？欢迎发送邮件反馈，帮助产品变得更好。</p>
            <a href="mailto:wonder1999@126.com" class="contact-link">wonder1999@126.com</a>
          </div>
          <div class="contact-card animate-on-scroll aos-delay-1">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>
              </svg>
            </div>
            <h3>开源项目</h3>
            <p>MookNote 基于 AGPL-3.0 协议开源，欢迎 Star、提交 Issue 或 PR。</p>
            <a href="https://github.com/dellevin/mooknote" target="_blank" rel="noopener" class="contact-link">GitHub 仓库</a>
          </div>
          <div class="contact-card animate-on-scroll aos-delay-2">
            <div class="contact-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <h3>社区交流</h3>
            <p>加入用户交流群，与其他用户分享使用心得和技巧。</p>
            <a href="#" class="contact-link" @click.prevent="openQRModal">加入群组</a>
          </div>
        </div>
      </div>
    </section>

    <!-- About -->
    <section class="about-section">
      <div class="container">
        <div class="about-content animate-on-scroll">
          <span class="section-eyebrow">ABOUT</span>
          <h2>关于 MookNote</h2>
          <p>MookNote 是一款专注于个人记录的应用，诞生于对简洁工具的追求。我们相信，好的工具应该像纸笔一样自然，不打扰思考，只记录生活。</p>
          <p>我们坚持数据归于用户：所有数据本地存储，无需注册账号，无需联网即可使用。同时提供 WebDAV 云同步与本地备份，让你自由选择数据的存储方式。</p>
          <p>应用采用 Flutter 框架开发，目前完整支持 Android、Windows 与 Linux 三平台，并以 AGPL-3.0 协议开源，欢迎任何形式的参与和贡献。</p>
        </div>
        <div class="about-stats">
          <div class="about-stat animate-on-scroll">
            <span class="as-number">4</span>
            <span class="as-label">核心模块</span>
          </div>
          <div class="about-stat animate-on-scroll aos-delay-1">
            <span class="as-number">2</span>
            <span class="as-label">支持平台</span>
          </div>
          <div class="about-stat animate-on-scroll aos-delay-2">
            <span class="as-number">6+</span>
            <span class="as-label">配色方案</span>
          </div>
          <div class="about-stat animate-on-scroll aos-delay-3">
            <span class="as-number">0</span>
            <span class="as-label">隐私收集</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Changelog -->
    <section class="changelog-section">
      <div class="container">
        <span class="section-eyebrow animate-on-scroll" style="text-align:center">CHANGELOG</span>
        <h2 class="section-title animate-on-scroll">更新日志</h2>
        <p class="section-subtitle animate-on-scroll">持续迭代，不断优化体验</p>
        <div class="timeline-scroll">
          <div class="timeline">
            <div v-for="(log, index) in changelogs" :key="index" class="timeline-item animate-on-scroll">
              <div class="timeline-marker"></div>
              <div class="timeline-content">
                <div class="timeline-header">
                  <h3>{{ log.version }}</h3>
                  <span class="timeline-date">{{ log.date }}</span>
                </div>
                <ul>
                  <li v-for="(feature, fIndex) in log.features" :key="fIndex">{{ feature }}</li>
                </ul>
              </div>
            </div>
            <div v-if="!changelogs.length" class="timeline-empty">加载中…</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      showQRModal: false,
      changelogs: []
    }
  },
  mounted() {
    fetch('https://api.mooknote.iletter.top/api/changelog')
      .then(res => res.json())
      .then(data => {
        if (data.items && Array.isArray(data.items)) {
          this.changelogs = data.items
          this.$nextTick(() => {
            this.initScrollObserver()
          })
        }
      })
      .catch(() => {})

    this.initScrollObserver()
  },
  methods: {
    openQRModal() {
      this.showQRModal = true
    },
    closeQRModal() {
      this.showQRModal = false
    },
    initScrollObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.1 })

      this.$nextTick(() => {
        const animatedElements = this.$el.querySelectorAll('.animate-on-scroll')
        animatedElements.forEach(el => observer.observe(el))
      })
    }
  }
}
</script>

<style scoped>
/* ===== Modal ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(16, 16, 20, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  animation: fadeIn 0.25s var(--ease-out);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: #fff;
  padding: 36px;
  border-radius: var(--radius-lg);
  text-align: center;
  position: relative;
  max-width: 360px;
  width: 90%;
  box-shadow: var(--shadow-lg);
  animation: slideUp 0.35s var(--ease-out);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-close {
  position: absolute;
  top: 14px;
  right: 14px;
  background: var(--color-bg-tertiary);
  border: none;
  font-size: 18px;
  line-height: 1;
  color: var(--color-text-secondary);
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s var(--ease-out);
}

.modal-close:hover {
  color: var(--color-text);
  transform: rotate(90deg);
}

.modal-content h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--color-text);
}

.modal-content p {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin-bottom: 22px;
}

.qr-image {
  width: 200px;
  height: 250px;
  border-radius: 12px;
  border: 1px solid var(--color-border);
}

/* ===== Page Header ===== */
.page-header {
  padding: 170px 24px 90px;
  background:
    radial-gradient(640px 360px at 50% 0%, rgba(0, 102, 255, 0.05), transparent 70%),
    linear-gradient(180deg, #FAFAFA 0%, #FFFFFF 100%);
  text-align: center;
}

.page-header h1 {
  font-size: clamp(32px, 4.5vw, 48px);
  font-weight: 700;
  letter-spacing: -1px;
  margin-bottom: 16px;
  color: var(--color-text);
}

.page-header p {
  font-size: 16.5px;
  color: var(--color-text-secondary);
}

/* ===== Contact Options ===== */
.contact-options {
  padding: 100px 24px;
  background: #fff;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.contact-card {
  padding: 40px 32px;
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  text-align: center;
  transition: transform 0.35s var(--ease-out), box-shadow 0.35s var(--ease-out), background 0.35s;
}

.contact-card:hover {
  transform: translateY(-6px);
  background: #fff;
  box-shadow: var(--shadow-lg);
}

.contact-icon {
  width: 60px;
  height: 60px;
  background: #fff;
  border: 1px solid var(--color-border);
  border-radius: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  color: var(--color-text);
  transition: all 0.35s var(--ease-out);
}

.contact-card:hover .contact-icon {
  background: var(--color-text);
  border-color: var(--color-text);
  color: #fff;
  transform: scale(1.06);
}

.contact-icon svg {
  width: 26px;
  height: 26px;
}

.contact-card h3 {
  font-size: 19px;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--color-text);
}

.contact-card p {
  font-size: 14.5px;
  color: var(--color-text-secondary);
  line-height: 1.8;
  margin-bottom: 22px;
}

.contact-link {
  display: inline-block;
  color: var(--color-text);
  font-size: 14.5px;
  font-weight: 600;
  text-decoration: none;
  padding-bottom: 2px;
  background: linear-gradient(var(--color-text), var(--color-text)) left bottom / 100% 1.5px no-repeat;
  transition: background-size 0.3s var(--ease-out), color 0.2s;
}

.contact-link:hover {
  background-size: 0% 1.5px;
  color: var(--color-text-muted);
}

/* ===== About Section ===== */
.about-section {
  padding: 100px 24px;
  background: var(--color-bg-secondary);
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.about-content {
  max-width: 680px;
  margin: 0 auto;
  text-align: center;
}

.about-content h2 {
  font-size: clamp(26px, 3.4vw, 36px);
  font-weight: 700;
  letter-spacing: -0.5px;
  margin-bottom: 24px;
  color: var(--color-text);
}

.about-content p {
  font-size: 15.5px;
  color: var(--color-text-secondary);
  line-height: 1.95;
  margin-bottom: 16px;
}

.about-stats {
  display: flex;
  justify-content: center;
  gap: 72px;
  flex-wrap: wrap;
  margin-top: 52px;
  padding-top: 48px;
  border-top: 1px solid var(--color-border-strong);
}

.about-stat {
  text-align: center;
}

.as-number {
  display: block;
  font-size: 34px;
  font-weight: 700;
  letter-spacing: -1px;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}

.as-label {
  font-size: 13px;
  color: var(--color-text-muted);
  margin-top: 6px;
  display: block;
  letter-spacing: 1px;
}

/* ===== Changelog ===== */
.changelog-section {
  padding: 100px 24px 110px;
  background: #fff;
}

.timeline-scroll {
  max-height: 520px;
  overflow-y: auto;
  padding-right: 10px;
}

.timeline-scroll::-webkit-scrollbar {
  width: 5px;
}

.timeline-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.timeline-scroll::-webkit-scrollbar-thumb {
  background: var(--color-border-strong);
  border-radius: 3px;
}

.timeline-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-muted);
}

.timeline {
  max-width: 720px;
  margin: 0 auto;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 7px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: var(--color-border);
  border-radius: 2px;
}

.timeline-item {
  display: flex;
  gap: 26px;
  margin-bottom: 32px;
  position: relative;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-marker {
  width: 16px;
  height: 16px;
  background: #fff;
  border: 4px solid var(--color-text);
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 24px;
  position: relative;
  z-index: 1;
  transition: transform 0.3s var(--ease-out);
}

.timeline-item:hover .timeline-marker {
  transform: scale(1.25);
}

.timeline-content {
  flex: 1;
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  padding: 24px 28px;
  border-radius: var(--radius-md);
  transition: transform 0.3s var(--ease-out), box-shadow 0.3s var(--ease-out), background 0.3s;
}

.timeline-item:hover .timeline-content {
  transform: translateX(5px);
  background: #fff;
  box-shadow: var(--shadow-md);
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.timeline-header h3 {
  font-size: 17px;
  font-weight: 700;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
}

.timeline-date {
  font-size: 12.5px;
  color: var(--color-text-muted);
  padding: 3px 10px;
  background: var(--color-bg-tertiary);
  border-radius: 999px;
  flex-shrink: 0;
}

.timeline-content ul {
  padding-left: 18px;
  color: var(--color-text-secondary);
  font-size: 14px;
  line-height: 2;
}

.timeline-content li::marker {
  color: var(--color-text-muted);
}

.timeline-empty {
  text-align: center;
  color: var(--color-text-muted);
  font-size: 14px;
  padding: 40px 0;
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .page-header {
    padding-top: 150px;
  }

  .about-stats {
    gap: 40px;
  }

  .timeline-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
